module.exports = __webpack_public_path__ + "static/assets/1b76fecc4b8815e7cf91bdb46966e4c0.png";